import React from 'react';
import { motion } from 'framer-motion';
import { FileText, FileDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './BookletsPage.css';

const booklets = [
  {
    key: 'doc1',
    file: '5.Информация о буклете по традиционной кухне Кыргызстана (03.06.2026).docx',
    type: 'Word',
  },
  {
    key: 'doc2',
    file: '5.Кыргызская традиционная местная еда F (03.06.2026).pdf',
    type: 'PDF',
  },
  {
    key: 'doc3',
    file: '5.(Web) Traditional Local Foods of Kyrgyzstan (03.06.2026)pdf.pdf',
    type: 'PDF',
  },
];

const fileIcons = {
  Word: <FileText size={40} />,
  PDF: <FileText size={40} />,
};

export default function BookletsPage() {
  const { t } = useTranslation();

  return (
    <section className="booklets-page">
      <div className="booklets-container">
        <motion.h1
          className="booklets-heading"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {t('booklets.title')}
        </motion.h1>

        <motion.p
          className="booklets-description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {t('booklets.description')}
        </motion.p>

        <div className="booklets-grid">
          {booklets.map((item, index) => (
            <motion.a
              key={item.key}
              href={`/files/${encodeURIComponent(item.file)}`}
              download
              className="booklet-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + index * 0.15, duration: 0.5 }}
              whileHover={{ scale: 1.02, y: -3 }}
            >
              <div className="booklet-icon">{fileIcons[item.type]}</div>
              <div className="booklet-info">
                <span className="booklet-type">{item.type}</span>
                <h3 className="booklet-name">{t(`booklets.${item.key}`)}</h3>
              </div>
              <span className="booklet-download">
                <FileDown size={24} />
                <span>{t('booklets.download')}</span>
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
